module.exports = __webpack_public_path__ + "static/img/payment-circle.3f10e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/payment-circle.png
// module id = 0GrK
// module chunks = 0